import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

import { DEFAULT_PAGINATION_LIMIT } from "../../../../../../../../globalConstants";
import { useQueryParams } from "../../../../../../../hooks/useQueryParams";
import useService from "../../../../../../../hooks/useService";
import PaginationControlsV2 from "../../../../../../global/PaginationControlsV2";

import { useProCliStore } from "./hooks/useProCliStore";
import ProviderListv2 from "./ProviderListv2";

const ProviderListv2Wrapper = ({ caseInfo }) => {
  const caseId = caseInfo?.id ?? caseInfo?.pk;
  const [providerInfoObj, setProviderInfoObj] = useState(null);
  const [loading, setLoading] = useState(false);
  const [providerClientRecCount, setProviderClientRecCount] = useState(0);
  const { filters, updateFilter, setFilters } = useQueryParams();
  const { shouldFetchData, setShouldFetchData, orderingVal } = useProCliStore();
  const providerClientRepository = useService("repositories/provider-client-status-repository");
  const urlLimit = Number.parseInt(filters?.get("limit") ?? "", 10);
  const urlOffset = Number.parseInt(filters?.get("offset") ?? "", 10);
  const effectiveLimit =
    Number.isFinite(urlLimit) && urlLimit > 0 ? urlLimit : DEFAULT_PAGINATION_LIMIT;
  const effectiveOffset = Number.isFinite(urlOffset) && urlOffset >= 0 ? urlOffset : 0;
  const currentPage = Math.floor(effectiveOffset / effectiveLimit) + 1;

  useEffect(() => {
    const hasLimit = filters.get("limit");
    const hasOffset = filters.get("offset");

    if (!hasLimit || !hasOffset) {
      const next = new URLSearchParams(filters);
      if (!hasLimit) {
        next.set("limit", String(DEFAULT_PAGINATION_LIMIT));
      }
      if (!hasOffset) {
        next.set("offset", "0");
      }
      setFilters(next);
    }
  }, [filters, setFilters]);

  useEffect(() => {
    setShouldFetchData(true);
  }, [caseId, effectiveLimit, effectiveOffset, orderingVal]);

  function handlePageChange(_, value) {
    updateFilter("offset", value ? (value - 1) * effectiveLimit : 0);
  }

  useEffect(() => {
    const fetchProviderInfo = async () => {
      setLoading(true);
      try {
        const providerClientObj = await providerClientRepository.query({
          case: caseId,
          limit: effectiveLimit,
          offset: effectiveOffset,
          ordering: orderingVal,
        });
        const providerClientRecCount = await providerClientRepository.getTotalCount();
        setProviderInfoObj(providerClientObj);
        setProviderClientRecCount(providerClientRecCount);
      } catch (error) {
        console.error("Error fetching provider info:", error);
      } finally {
        setShouldFetchData(false);
        setLoading(false);
      }
    };
    if (shouldFetchData && !!caseId) {
      fetchProviderInfo();
    }
  }, [caseId, effectiveLimit, effectiveOffset, orderingVal, shouldFetchData]);

  if (loading) {
    return (
      <div className="pb-2 mt-2">
        <div className="mx-auto w-fit">
          <CircularProgress color="secondary" />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="overflow-hidden sm:h-[80vh]">
        {providerInfoObj && <ProviderListv2 caseInfo={caseInfo} providerInfo={providerInfoObj} />}
      </div>
      <div className="flex items-center justify-center w-full my-4">
        <PaginationControlsV2
          currentPage={currentPage}
          handleChange={handlePageChange}
          resultCount={providerClientRecCount}
          resultLimit={effectiveLimit}
        />
      </div>
    </>
  );
};
export default ProviderListv2Wrapper;
